import { Outlet } from 'react-router-dom';
import './BookingLayout.css';

// Public, unauthenticated shell for the client booking app — Get It Media branded,
// no admin chrome. Rendered for /book and /booking routes.
export default function BookingLayout() {
  return (
    <div className="booking-layout">
      <header className="booking-topbar">
        <div className="booking-brand">
          <span className="booking-mark">📅</span>
          <span className="booking-brand-name">Get It Media</span>
        </div>
      </header>
      <main className="booking-main">
        <Outlet />
      </main>
      <footer className="booking-footer">
        <p>Get It Media · Get It Magazine — Gold Coast, QLD</p>
      </footer>
    </div>
  );
}
